import QuestionLabel from './QuestionLabel';
import SafeHtml from '../../SafeHtml';
import type { QuestionComponentProps } from '~/lib/Questions/Questions.types';
import { FC } from 'react';
import SignaturePanel from './components/SignaturePanel';
import type { SignatureValue } from './components/SignaturePanel/SignaturePanel.types';

const SignatureQuestion: FC<QuestionComponentProps<SignatureValue>> = ({
    label,
    settings,
    isReadOnly,
    setValue,
    value,
}) => {
    return (
        <div>
            <QuestionLabel label={label} settings={settings} />

            <div>
                <SafeHtml html={settings?.display} />
                <SignaturePanel
                    isReadOnly={isReadOnly}
                    setValue={setValue}
                    value={value}
                />
            </div>
        </div>
    );
};

export default SignatureQuestion;
